import type { ErrorDebugLogPayload } from '../../diagnostics/errorDebugLogs/types';
import type { PerformanceDebugLogPayload } from '../../diagnostics/perfDebugLogs/types';

import type {
  ClearErrorLogsAction,
  ClearPerformanceLogsAction,
  LogApiErrorAction,
  LogApiPerformanceAction,
  LogComponentErrorAction,
  LogComponentPerformanceAction,
  SetDiagnosticsLoggingEnabledAction,
} from './actions.types';

type SetDiagnosticsLoggingEnabled = (payload: boolean) => SetDiagnosticsLoggingEnabledAction;
export const setDiagnosticsLoggingEnabled: SetDiagnosticsLoggingEnabled = (payload) => ({
  type: 'DIAGNOSTICS.SET_LOGGING_ENABLED',
  payload,
});

type LogComponentPerformance = (payload: PerformanceDebugLogPayload) => LogComponentPerformanceAction;
export const logComponentPerformance: LogComponentPerformance = (payload) => ({
  type: 'DIAGNOSTICS.LOG_COMPONENT_PERFORMANCE',
  payload,
});

type LogApiPerformance = (payload: PerformanceDebugLogPayload) => LogApiPerformanceAction;
export const logApiPerformance: LogApiPerformance = (payload) => ({
  type: 'DIAGNOSTICS.LOG_API_PERFORMANCE',
  payload,
});

type ClearPerformanceLogs = () => ClearPerformanceLogsAction;
export const clearPerformanceLogs: ClearPerformanceLogs = () => ({
  type: 'DIAGNOSTICS.CLEAR_PERFORMANCE_LOGS',
});

type LogComponentError = (componentName: string, error: unknown) => LogComponentErrorAction;
export const logComponentError: LogComponentError = (componentName, error) => {
  const message = error instanceof Error ? error.message : undefined;

  return {
    type: 'DIAGNOSTICS.LOG_COMPONENT_ERROR',
    payload: {
      name: componentName,
      message,
    },
  };
};

type LogApiError = (payload: ErrorDebugLogPayload) => LogApiErrorAction;
export const logApiError: LogApiError = (payload) => ({
  type: 'DIAGNOSTICS.LOG_API_ERROR',
  payload,
});

type ClearErrorLogs = () => ClearErrorLogsAction;
export const clearErrorLogs: ClearErrorLogs = () => ({
  type: 'DIAGNOSTICS.CLEAR_ERROR_LOGS',
});
